import React, { Component } from "react";
import "./contactus.css";

export default class Contactus extends Component {
  render() {
    return (
      <div>
        <div className="contactus">
          <div className="contactus-conatainer">
            <h1>
              Need a <span>Website ?</span> <p id="hiddenButton" onClick={this.props.handleContact}>Contact us</p>
            </h1>
            <button type="button" onClick={this.props.handleContact}>
              Click here
            </button>
          </div>
        </div>
      </div>
    );
  }
}
